import { render, staticRenderFns } from "./PredefinedItem.vue?vue&type=template&id=0f34e45c&scoped=true&"
import script from "./PredefinedItem.vue?vue&type=script&lang=ts&"
export * from "./PredefinedItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34e45c",
  null
  
)

export default component.exports